import { getAILimit } from '../config/tiers';

const STORAGE_KEY = 'aiUsage';

const getMonth = () => new Date().toISOString().slice(0, 7);

const getUsage = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    if (raw.month !== getMonth()) return { month: getMonth(), recipeAI: 0, overloadAI: 0 };
    return raw;
  } catch {
    return { month: getMonth(), recipeAI: 0, overloadAI: 0 };
  }
};

const saveUsage = (usage) => {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(usage));
};

export const checkAILimit = (tier, feature) => {
  const limit = getAILimit(tier, feature);
  if (limit === 0) return { allowed: false, remaining: 0, limit };
  const usage = getUsage();
  const used = usage[feature] || 0;
  return { allowed: used < limit, remaining: Math.max(0, limit - used), limit };
};

export const recordAIUsage = (feature) => {
  const usage = getUsage();
  usage[feature] = (usage[feature] || 0) + 1;
  saveUsage(usage);
};

export const getUsageSummary = (tier) => {
  const usage = getUsage();
  return {
    recipeAI: { used: usage.recipeAI || 0, limit: getAILimit(tier, 'recipeAI') },
    overloadAI: { used: usage.overloadAI || 0, limit: getAILimit(tier, 'overloadAI') },
  };
};
